import { get, isNull } from 'lodash';
import { densities } from 'constants/products';

export const convert = ({ from, to, conversionFactor }) => {
  if(from.u === to.u) {
    return from;
  }

  if (isNull(from.q)) {
    return {...from, u: to.u};
  }

  const converted = Object.assign({}, from, to);
  const { q: originalRate } = from;
  const { multiplier } = conversionFactor;

  converted.q = originalRate * multiplier;
  return converted;
};

export const getDensityForProduct = (product) => {
  const productSpecificGravity = get(product, 'specificGravity');
  return productSpecificGravity * densities.WATER;
};